import React from "react";

export default function LegalModal({ isOpen, onClose, type }) {
  if (!isOpen) return null;

  const getContent = () => {
    switch (type) {
      case "impressum":
        return {
          title: "Impressum",
          content: (
            <div className="space-y-4 text-sm text-slate-700">
              <p className="font-semibold text-slate-900">Angaben gemäß § 5 TMG</p>
              
              <div>
                <p className="font-medium">Verantwortlich für den Inhalt:</p>
                <p>Diese App wird privat entwickelt und bereitgestellt.</p>
                <p className="mt-2">Kontakt:</p>
                <p>Kevin Bramke</p>
                <p>Hoyerswerdaer Str. 11</p>
                <p>02959 Schleife</p>
                <p>support@burningteam.de</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">Haftungsausschluss</p>
                <p><strong>Haftung für Inhalte:</strong></p>
                <p>Die Inhalte dieser App wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
              </div>

              <div>
                <p><strong>Haftung für Links:</strong></p>
                <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
              </div>

              <div>
                <p><strong>Urheberrecht:</strong></p>
                <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <p className="text-xs text-slate-500">
                  Stand: November 2025
                </p>
              </div>
            </div>
          ),
        };

      case "nutzungsbedingungen":
        return {
          title: "Nutzungsbedingungen",
          content: (
            <div className="space-y-4 text-sm text-slate-700">
              <p className="font-semibold text-slate-900">Allgemeine Nutzungsbedingungen</p>
              
              <div>
                <p className="font-medium">1. Geltungsbereich</p>
                <p>Diese Nutzungsbedingungen gelten für die Nutzung dieser App. Mit der Registrierung und Nutzung der App erklären Sie sich mit diesen Bedingungen einverstanden.</p>
              </div>

              <div>
                <p className="font-medium">2. Zweck der App</p>
                <p>Diese App richtet sich ausschließlich an PM-International Teampartner und dient der internen Organisation und Verwaltung. Die App steht in keiner offiziellen Verbindung zu PM-International und ist ein privates Hilfsmittel.</p>
              </div>

              <div>
                <p className="font-medium">3. Nutzungsrechte</p>
                <p>Die Nutzung der App ist nur für registrierte PM-International Teampartner gestattet. Die Weitergabe von Zugangsdaten an Dritte ist nicht erlaubt. Jeder Nutzer ist für die Geheimhaltung seiner Zugangsdaten selbst verantwortlich.</p>
              </div>

              <div>
                <p className="font-medium">4. Pflichten des Nutzers</p>
                <p>Der Nutzer verpflichtet sich:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>Die App nur zu rechtmäßigen Zwecken zu nutzen</li>
                  <li>Keine missbräuchlichen oder rechtswidrigen Inhalte einzugeben</li>
                  <li>Die eingegebenen Daten eigenständig auf Richtigkeit zu prüfen</li>
                  <li>Keine technischen Maßnahmen zu ergreifen, die die App beeinträchtigen könnten</li>
                </ul>
              </div>

              <div>
                <p className="font-medium">5. Gewährleistungsausschluss</p>
                <p>Die App wird "wie besehen" zur Verfügung gestellt. Es besteht keine Gewährleistung für:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>Die ständige Verfügbarkeit der App</li>
                  <li>Die Richtigkeit, Vollständigkeit oder Aktualität der bereitgestellten Funktionen</li>
                  <li>Die Fehlerfreiheit der App</li>
                  <li>Die Eignung für einen bestimmten Zweck</li>
                </ul>
              </div>

              <div>
                <p className="font-medium">6. Haftungsbeschränkung</p>
                <p>Der Betreiber haftet nur für Schäden, die auf Vorsatz oder grober Fahrlässigkeit beruhen. Eine Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht wesentliche Vertragspflichten betroffen sind. Die App ersetzt keine professionelle steuerliche oder rechtliche Beratung.</p>
              </div>

              <div>
                <p className="font-medium">7. Änderungen der Nutzungsbedingungen</p>
                <p>Der Betreiber behält sich vor, diese Nutzungsbedingungen jederzeit zu ändern. Änderungen werden den Nutzern rechtzeitig mitgeteilt. Die fortgesetzte Nutzung der App nach Änderung der Bedingungen gilt als Zustimmung zu den neuen Bedingungen.</p>
              </div>

              <div>
                <p className="font-medium">8. Beendigung der Nutzung</p>
                <p>Der Nutzer kann seine Registrierung jederzeit beenden. Der Betreiber kann den Zugang zur App bei Verstoß gegen diese Nutzungsbedingungen oder bei missbräuchlicher Nutzung sperren.</p>
              </div>

              <div>
                <p className="font-medium">9. Salvatorische Klausel</p>
                <p>Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder werden, berührt dies nicht die Wirksamkeit der übrigen Bestimmungen.</p>
              </div>

              <div>
                <p className="font-medium">10. Anwendbares Recht</p>
                <p>Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <p className="text-xs text-slate-500">
                  Stand: November 2025
                </p>
              </div>
            </div>
          ),
        };

      case "privacy":
        return {
          title: "Datenschutzerklärung",
          content: (
            <div className="space-y-4 text-sm text-slate-700">
              <div>
                <p className="font-semibold text-slate-900 mb-2">1. Verantwortlicher</p>
                <p>Verantwortlich für die Datenverarbeitung im Sinne der DSGVO ist:</p>
                <p className="mt-2">Kevin Bramke</p>
                <p>Hoyerswerdaer Str. 11</p>
                <p>02959 Schleife</p>
                <p>support@burningteam.de</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">2. Erhebung und Verarbeitung personenbezogener Daten</p>
                <p>Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen App sowie unserer Inhalte und Leistungen erforderlich ist.</p>
                
                <p className="mt-3">Zu den verarbeiteten Daten gehören insbesondere:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>Registrierungsdaten (Name, E-Mail-Adresse, Passwort-Hash, Benutzer-ID)</li>
                  <li>Nutzungsdaten (Datum, Uhrzeit, IP-Adresse, Gerätetyp, App-Version)</li>
                  <li>Geschäftliche Daten des Nutzers (Inventar, Produkte, Rechnungen, Einstellungen)</li>
                  <li>Daten Dritter, die der Nutzer eingibt (z. B. Kunden, Teampartner, Kontakte), einschließlich:
                    <ul className="list-circle ml-6 mt-1">
                      <li>Namen, Kontaktdaten, Notizen</li>
                      <li>Termine, organisatorische Informationen</li>
                      <li>Bestellungen, Rechnungsdaten, Preisangaben</li>
                    </ul>
                  </li>
                </ul>
                
                <p className="mt-3 font-medium">Die Verantwortung für die rechtmäßige Eingabe dieser Daten Dritter liegt beim Nutzer.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">3. Rechtsgrundlagen der Verarbeitung</p>
                <p>Die Verarbeitung erfolgt auf Grundlage von:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung / Bereitstellung der App)</li>
                  <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung für freiwillige Angaben)</li>
                  <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Stabilität, Sicherheit und Verbesserung der App)</li>
                </ul>
                
                <p className="mt-3">Die Verarbeitung von personenbezogenen Daten Dritter erfolgt ebenfalls nach Art. 6 Abs. 1 lit. f DSGVO (Organisationszwecke des Nutzers). Die Verantwortung für die rechtmäßige Verarbeitung dieser Daten liegt beim Nutzer.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">4. Weitergabe von Daten</p>
                <p>Personenbezogene Daten werden nur weitergegeben, wenn:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>dies zur Bereitstellung der App erforderlich ist (z. B. Hosting, Datenbank),</li>
                  <li>eine gesetzliche Verpflichtung besteht,</li>
                  <li>der Nutzer eingewilligt hat.</li>
                </ul>
                
                <p className="mt-3">Mögliche Dienstleister:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>MongoDB Atlas (Cloud-Datenbank)</li>
                  <li>PayPal (bei freiwilliger Unterstützung)</li>
                </ul>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">5. Speicherdauer</p>
                <p>Daten werden nur so lange gespeichert, wie dies für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Danach erfolgt Löschung oder Anonymisierung.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">6. Sicherheit</p>
                <p>Wir schützen personenbezogene Daten u. a. durch:</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>TLS/HTTPS</li>
                  <li>Passwort-Hashing (bcrypt)</li>
                  <li>Zugriffsbeschränkungen</li>
                  <li>Backups</li>
                  <li>Datenminimierung</li>
                </ul>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">7. Rechte der betroffenen Personen</p>
                <p>Nutzer haben folgende Rechte:</p>
                <p className="mt-2">Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerspruch sowie Widerruf erteilter Einwilligungen. Anfragen richten Sie an den Verantwortlichen.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">8. App-Berechtigungen</p>
                <p>Derzeit werden keine speziellen Geräteberechtigungen benötigt.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">9. Automatische Datenerfassung</p>
                <p>Es werden aktuell keine Tracking- oder Analyse-Tools eingesetzt.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">10. Änderungen der Datenschutzerklärung</p>
                <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen. Die jeweils aktuelle Version ist jederzeit in der App abrufbar.</p>
              </div>

              <div>
                <p className="font-semibold text-slate-900 mb-2">11. Beschwerderecht</p>
                <p>Nutzer können sich bei einer Datenschutzaufsichtsbehörde beschweren, wenn sie Verstöße vermuten.</p>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <p className="text-xs text-slate-500">
                  Stand: November 2025
                </p>
              </div>
            </div>
          ),
        };

      case "terms":
        return {
          title: "Haftungsausschluss",
          content: (
            <div className="space-y-4 text-sm text-slate-700">
              <p className="font-semibold text-slate-900">Haftungsausschluss / Disclaimer</p>
              
              <div>
                <p className="font-medium">1. Inhalt des Onlineangebotes</p>
                <p>Der Betreiber übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Betreiber, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Betreibers kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.</p>
              </div>

              <div>
                <p className="font-medium">2. Keine rechtliche oder steuerliche Beratung</p>
                <p>Die Inhalte dieser App stellen keine rechtliche, steuerliche oder sonstige fachliche Beratung dar. Alle bereitgestellten Funktionen und Berechnungen dienen ausschließlich der internen Organisation und dürfen nicht als Grundlage für rechtliche oder steuerliche Entscheidungen verwendet werden. Für rechtliche oder steuerliche Fragen konsultieren Sie bitte einen qualifizierten Rechtsanwalt oder Steuerberater.</p>
              </div>

              <div>
                <p className="font-medium">3. Keine Verbindung zu PM-International</p>
                <p>Diese App wird privat entwickelt und bereitgestellt. Sie steht in keinerlei offizieller Verbindung zu PM-International. Die App ist ausschließlich ein Hilfsmittel für Teampartner zur internen Organisation und ist nicht von PM-International autorisiert, unterstützt oder überprüft.</p>
              </div>

              <div>
                <p className="font-medium">4. Eigenverantwortung des Nutzers</p>
                <p>Der Nutzer ist verpflichtet, alle in der App eingegebenen Daten sowie alle bereitgestellten Berechnungen eigenständig zu prüfen und zu verifizieren. Der Nutzer trägt die volle Verantwortung für die Richtigkeit seiner Eingaben und die daraus resultierenden Ergebnisse.</p>
              </div>

              <div>
                <p className="font-medium">5. Verfügbarkeit der App</p>
                <p>Der Betreiber übernimmt keine Garantie für die ständige Verfügbarkeit der App. Es kann zu Ausfallzeiten, Wartungsarbeiten oder technischen Problemen kommen. Der Nutzer hat keinen Anspruch auf ständige Verfügbarkeit.</p>
              </div>

              <div>
                <p className="font-medium">6. Datenverlust</p>
                <p>Obwohl der Betreiber Maßnahmen zur Datensicherung ergreift, kann ein Datenverlust nicht vollständig ausgeschlossen werden. Der Nutzer wird dringend empfohlen, regelmäßig eigene Backups seiner wichtigen Daten anzufertigen. Für Datenverluste wird keine Haftung übernommen.</p>
              </div>

              <div>
                <p className="font-medium">7. Änderungen und Aktualisierungen</p>
                <p>Der Betreiber behält sich vor, die App sowie deren Funktionen jederzeit zu ändern, zu erweitern oder einzustellen. Es besteht kein Anspruch auf Aufrechterhaltung bestimmter Funktionen.</p>
              </div>

              <div>
                <p className="font-medium">8. Haftungsbeschränkung</p>
                <p>Die Haftung des Betreibers für Schäden, die durch die Nutzung oder Nichtnutzung der App entstehen, ist auf Vorsatz und grobe Fahrlässigkeit beschränkt. Dies gilt nicht für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.</p>
              </div>

              <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <p className="text-xs text-amber-900 font-semibold mb-2">WICHTIGER HINWEIS:</p>
                <p className="text-xs text-amber-800">
                  Diese App ist ein privates Hilfsmittel und ersetzt keine professionelle Beratung. Alle Angaben erfolgen ohne Gewähr. Der Nutzer ist verpflichtet, alle Daten eigenständig zu prüfen und trägt die volle Verantwortung für die Verwendung der bereitgestellten Informationen.
                </p>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <p className="text-xs text-slate-500">
                  Stand: November 2025
                </p>
              </div>
            </div>
          ),
        };

      default:
        return {
          title: "Information",
          content: <p className="text-sm text-slate-700">Keine Inhalte verfügbar.</p>,
        };
    }
  };

  const { title, content } = getContent();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-slate-200">
          <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 text-2xl font-bold leading-none"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {content}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-slate-200 bg-slate-50">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-colors"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}
